module.exports = __webpack_public_path__ + "img/picture-home-2@2x.a6cf1a48.jpg";